import finnishLabels from "./finnish_options";
import englishLabels from "./english_options";
export var languageOptions = {
  fi_FI: finnishLabels,
  en_US: englishLabels
};